<template>
  <div>
    <v-row class="infor">
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          Leczenie i rehabilitacja
        </div>
        <div class="textWhyPhone">
          W naszym gabinecie uzyskasz profesjonalną pomoc w leczeniu urazów oraz
          bólu.
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          Leczenie i rehabilitacja
        </div>
        <div class="textWhy">
          W naszym gabinecie uzyskasz profesjonalną pomoc w leczeniu urazów oraz
          bólu.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-row v-if="browserSize.sm == true || browserSize.xs == true">
        <v-col cols="12">
          <v-icon size="75" class="iconMargin">fas fa-first-aid</v-icon>
          <div
            class="display-1 font-weight-black grey--text text-center iconMargin"
          >
            Leczenie Bólu
          </div>
          <div class="textCenter iconMargin">
            Korzystając z uznanych na całym świecie metod walki z bólem,
            jesteśmy w stanie go skutecznie leczyć.
          </div>
        </v-col>
        <v-col cols="12">
          <v-icon size="75" class="iconMargin">fas fa-user-injured</v-icon>
          <div
            class="display-1 font-weight-black grey--text text-center iconMargin"
          >
            Rehabilitacja Pourazowa
          </div>
          <div class="textCenter iconMargin">
            Ma bardzo szerokie zastosowanie ponieważ różny może być charakter
            urazu (bezpośredni, przeciążeniowy) jak również może dotyczyć
            różnych struktur układu mięśniowo – szkieletowego ale i nerwowego.
          </div>
        </v-col>
        <v-col cols="12">
          <v-icon size="75" class="iconMargin">fas fa-running </v-icon>
          <div
            class="display-1 font-weight-black grey--text text-center iconMargin"
          >
            Fizjoterapia Sportowa
          </div>
          <div class="textCenter iconMargin">
            Skierowana jest do osób aktywnych zajmujących się sportem zarówno
            zawodowo jak i amatorsko. Obejmuje leczenie oraz profilaktykę urazów
            sportowych.
          </div>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="4">
          <v-icon size="75" class="iconMargin">fas fa-first-aid</v-icon>
          <div
            class="display-1 font-weight-black grey--text text-center iconMargin"
          >
            Leczenie Bólu
          </div>
          <div class="textCenter iconMargin">
            Zdecydowana wiekszość pacjentów to pacjenci z bólem. Korzystając z
            metod walki z bólem, jesteśmy w stanie go skutecznie leczyć.
          </div>
        </v-col>
        <v-col cols="4">
          <v-icon size="75" class="iconMargin">fas fa-user-injured</v-icon>
          <div
            class="display-1 font-weight-black grey--text text-center iconMargin"
          >
            Rehabilitacja Pourazowa
          </div>
          <div class="textCenter iconMargin">
            Ma bardzo szerokie zastosowanie ponieważ różny może być charakter
            urazu oraz może dotyczyć różnych struktur układu mięśniowo –
            szkieletowego ale i nerwowego.
          </div>
        </v-col>
        <v-col cols="4">
          <v-icon size="75" class="iconMargin">fas fa-running</v-icon>
          <div
            class="display-1 font-weight-black grey--text text-center iconMargin"
          >
            Fizjoterapia Sportowa
          </div>
          <div class="textCenter iconMargin">
            Skierowana jest do osób aktywnych zajmujących się sportem zarówno
            zawodowo jak i amatorsko. Obejmuje leczenie oraz profilaktykę urazów
            sportowych.
          </div>
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application .grey--text {
  color: #414149 !important;
}
.infor {
  padding: 40px;
}
.infText {
  margin: auto;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  text-align: justify;
  text-align-last: left;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.textCenter {
  text-align-last: left;
}
.iconMargin {
  margin-bottom: 2vh;
}
h1 {
  margin: auto;
}
</style>
